import { useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import useCommonFetch from "../../../../../hooks/useCommonFetch";
import {
  createCategory,
  deleteCategory,
  getCategoryDetail,
  updateCategory,
} from "../../../../../services/workspace/inventory.service";
import CommonTable from "../../../../components/table/table";
import { useState } from "react";
import CommonModal from "../../../../components/modals/commonModel";
import CommonForm from "../../../../components/form/form";

const items = [
  { label: "Category", path: "/inventory/category" },
  { label: "Category Detail", path: "" },
];

const CategoryDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isEditValue, setIsEditValue] = useState(null);

  const actions_type = {
    DELETE: "DELETE",
    ADD_EDIT: "ADD_EDIT",
  };

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    fetchData,
    handleDelete,
  } = useCommonFetch(getCategoryDetail, {
    id: id,
    dataPath: "category",
    errorMessage: "Failed to fetch category detail!",
    customParams: {
      only_parent: true,
      with: "subCategory",
    },
    dataTransformer: (data) => {
      if (data && Array.isArray(data.subCategory)) {
        const transformedData = data.subCategory.map((item) => ({
          ...item,
          id: { data: item.id, variant: "text" },
          uuid: { data: item.uuid, variant: "text" },
          name: { data: item.name, variant: "text" },
          description: { data: item.description ?? "-", variant: "text" },
          createdAt: { data: item.created_at, variant: "date" },
          actions: { data: item.id, variant: "text" },
        }));

        const actionButton = {
          delete: (item) => {
            handleDelete(item.uuid.data, deleteCategory, {
              successMessage: "Sub-category deleted successfully!",
              errorMessage: "Failed to delete sub-category!",
            });
          },
          edit: (item) => {
            const initialData = {
              uuid: item.uuid.data, // 👈 keep uuid for update
              name: item.name.data,
            };
            setIsEditValue(initialData);
            openModal(item, actions_type.ADD_EDIT);
          },
        };

        return {
          data: transformedData,
          action: actionButton,
          parent: {
            id: data.id, // 👈 keep parent id here
            name: data.name,
            description: data.description,
            createdAt: data.created_at,
          },
        };
      }
      return { data: [], action: {}, parent: null };
    },
  });

  const TableHeaderData = [
    { label: "Name", key: "name" },
    { label: "Created At", key: "createdAt" },
  ];

  const subCategoryFields = [
    {
      name: "name",
      label: "Sub-Category Name",
      type: "text",
      placeholder: "Enter subcategory name",
      required: true,
      minLength: 2,
      maxLength: 40,
    },
  ];

  const handleCancel = () => {
    setIsEditValue(null);
    closeModal();
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        ...values,
        parent_id: tableData?.parent?.id, // ✅ correct parent id
      };

      if (isEditValue) {
        await handleUpdate(payload, isEditValue.uuid, updateCategory, {
          successMessage: "Sub-category updated successfully!",
          errorMessage: "Failed to update sub-category!",
        });
      } else {
        await handleCreate(payload, createCategory, {
          successMessage: "Sub-category created successfully!",
          errorMessage: "Failed to create sub-category!",
        });
      }
    } finally {
      setSubmitting(false);
      resetForm();
      setIsEditValue(null);
      closeModal(true);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
      />

      <div className="p-4 bg-white rounded-md text-theme">
        <h2 className="text-lg font-semibold">{tableData?.parent?.name}</h2>
        <p>{tableData?.parent?.description}</p>
      </div>

      <CommonTable
        search={search}
        TableHeaderData={TableHeaderData}
        tabledata={tableData?.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={loading}
        action={tableData?.action}
      />

      {action === actions_type.ADD_EDIT && (
        <CommonModal
          modalSize="lg"
          headerTitle={isEditValue ? "Edit Sub-Category" : "Add Sub-Category"}
          onClose={handleCancel}
          show={true}
        >
          <CommonForm
            fields={subCategoryFields}
            initialData={isEditValue || {}}
            onSubmit={handleSubmit}
            submitButtonText="Submit"
            onCancel={handleCancel}
            cancelButtonText="Cancel"
            columnsPerRow={1}
            gap="gap-4"
            rowClassName=""
            fieldClassName="bg-white p-3 rounded shadow-sm"
          />
        </CommonModal>
      )}
    </div>
  );
};

export default CategoryDetail;
